'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.getPage = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNavigation = function getNavigation(_ref, route) {
  var navigation = _ref.navigation;

  if (navigation) {
    return navigation.map(function (nav) {
      return (0, _extends3.default)({}, nav, {
        isSelected: (nav.href || '').indexOf(route) !== -1
      });
    });
  }

  return null;
};

var getPage = exports.getPage = function getPage(route, state) {
  var page = state.pages[route];

  var navigation = getNavigation(page, route.split('/').pop());

  return (0, _extends3.default)({}, page, {
    navigation: navigation
  });
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var route = ownProps.routeParams.splat.split('/').filter(function (el) {
    return el;
  }).join('/');
  return {
    route: route,
    page: getPage(route, state)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps() {
  return {};
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Page/selectors.js
// module id = 1104
// module chunks = 0